// Customize value for r4q translation
if (window.BSS_BCP_V2?.r4q?.translation) {
    if (window.Shopify?.locale === "fr") {
        BSS_BCP_V2.r4q.translation = {
            "quote_button_content": "Ajouter au devis",
            "total_quantity": "Quantité totale",
            "modal_header_title": "Demande de devis",
            "product_section_heading": "Produits demandés",
            "product_table_product_variant": "Variante : ",
            "product_table_product_sku": "SKU : ",
            "product_table_product_barcode": "Code-barres : ",
            "product_table_product_type": "Type : ",
            "product_table_product_vendor": "Vendeur : ",
            "product_table_product_available_quantity": "Quantité disponible : ",
            "product_table_product_offer_button": "Proposer un prix",
            "product_table_product_offer_price": "Prix proposé : ",
            "product_table_product_offer_placeholder": "Votre prix",
            "product_table_product_note_placeholder": "Ajouter des exigences supplémentaires pour ce produit",
            "product_empty_heading": "Aucun article dans votre liste de demande de devis",
            "product_empty_message": "Veuillez rechercher et ajouter des produits pour demander un devis",
            "add_items_success_heading": "Articles ajoutés à la liste de demande de devis",
            "add_items_success_message": "Vous avez ajouté avec succès les articles à votre liste de demande de devis.",
            "add_items_failure_heading": "Échec de l'ajout des articles",
            "add_items_failure_message": "Un problème est survenu lors de l'ajout des articles à votre liste de demande de devis. Veuillez réessayer.",
            "toast_view_quote_button": "Voir la liste de demande de devis",
            "eligible_notice_title": "Avis d'éligibilité à la demande de devis",
            "eligible_all_items_invalid": "Malheureusement, aucun des articles n'est éligible pour une demande de devis. Veuillez ajouter des produits éligibles pour continuer.",
            "eligible_exist_invalid_items": "Certains articles ne sont pas éligibles pour un devis :",
            "eligible_continue_or_return": "Vous pouvez continuer avec les articles éligibles ou revenir en arrière pour ajuster.",
            "eligible_return_button": "Retour",
            "eligible_continue_button": "Continuer",
            "form_section_heading": "Remplir les informations",
            "modal_footer_cancel_button": "Continuer vos achats",
            "modal_footer_submit_button": "Soumettre la demande",
            "state_file_uploading": "Téléchargement du fichier en cours",
            "file_choose_button": "Choisir un fichier",
            "file_replace_button": "Remplacer le fichier",
            "after_submit_heading": "Demande de devis envoyée avec succès",
            "after_submit_message": "Votre demande de devis a bien été reçue. Notre équipe va l'examiner et reviendra vers vous sous peu.",
            "after_submit_quote_id": "ID du devis : #",
            "after_submit_back_button": "Retour à la boutique",
            "error_required": "{{label}} est requis",
            "error_invalid": "{{label}} est invalide",
            "error_file_type": "Le type de fichier doit être l'un des suivants : .csv, .doc, .docx, .gif, .jpg, .jpeg, .png, .pdf, .wav, .xls, .xlsx, .zip, .mp4, .txt",
            "error_file_size": "La taille du fichier ne doit pas dépasser {{maxSize}} Mo",
            "error_video_size": "La taille de la vidéo ne doit pas dépasser {{maxSize}} Mo",
            "error_video_width": "La largeur de la vidéo doit être comprise entre {{minWidth}}px et {{maxWidth}}px",
            "error_video_height": "La hauteur de la vidéo doit être comprise entre {{minHeight}}px et {{maxHeight}}px",
            "error_video_resolution": "La résolution de la vidéo ne doit pas dépasser {{maxResolution}}MP",
            "error_video_duration": "La durée de la vidéo doit être comprise entre {{minDuration}} secondes et {{maxDuration}} secondes",
            "error_image_size": "La taille de l'image ne doit pas dépasser {{maxSize}} Mo",
            "error_image_aspect_ratio": "Le rapport d'aspect de l'image doit être compris entre {{minAspectRatio}} et {{maxAspectRatio}}",
            "error_image_resolution": "La résolution de l'image ne doit pas dépasser {{maxResolution}}MP",
            "error_min_value": "{{label}} doit être supérieur ou égal à {{min}}",
            "error_max_value": "{{label}} doit être inférieur ou égal à {{max}}",
            "error_min_length": "{{label}} n'a pas atteint la limite minimale de {{minLength}} caractères",
            "error_max_length": "{{label}} a dépassé la limite maximale de {{maxLength}} caractères",
            "history_created_at": "Date de création",
            "history_restricted_heading": "Cette page est réservée aux clients connectés",
            "history_restricted_description": "Veuillez vous connecter à votre compte pour accéder à cette page",
            "history_restricted_primary_button": "Se connecter",
            "history_restricted_secondary_button": "Retourner",
            "history_page_title": "Mon historique de devis",
            "history_page_subtitle": "Suivez vos devis créés et accédez aux détails complets de chaque demande.",
            "history_search_quote": "Rechercher un devis",
            "history_filter_status": "Statut",
            "history_filter_all": "Tout",
            "history_sort_by": "Trier par",
            "history_sort_newest": "Plus récent",
            "history_sort_oldest": "Plus ancien",
            "history_empty_heading": "Aucun devis disponible",
            "history_empty_description": "Votre liste de devis est vide ou aucun devis ne correspond à votre recherche et à vos filtres",
            "history_quote_name": "Devis n°",
            "history_table_customer": "Client",
            "history_table_company": "Entreprise",
            "history_table_location": "Emplacement",
            "quote_status_unread": "Non lu",
            "quote_status_review": "En cours de révision",
            "quote_status_converted": "Converti",
            "quote_status_rejected": "Rejeté",
            "quote_proposal_sent": "Proposition envoyée",
            "detail_page_title": "Détail du devis n°",
            "detail_table_product": "PRODUIT",
            "detail_table_quoted_price": "PRIX DU DEVIS",
            "detail_table_quantity": "QUANTITÉ",
            "detail_table_total": "TOTAL",
            "detail_table_sku": "SKU",
            "detail_table_barcode": "Code-barres",
            "detail_table_vendor": "Vendeur",
            "detail_table_note": "Note",
            "detail_payment_heading": "INFORMATIONS DE PAIEMENT",
            "detail_payment_subtotal": "Sous-total",
            "detail_payment_items": "article(s)",
            "detail_payment_shipping": "Livraison",
            "detail_payment_tax": "Taxe",
            "detail_payment_total": "Montant final",
            "detail_payment_tax_exempt": "Exonéré de taxe",
            "detail_payment_taxes_included": "Incluses",
            "detail_checkout_button": "PASSER À LA CAISSE",
            "detail_payment_terms": "CONDITIONS DE PAIEMENT",
            "detail_customer_heading": "INFORMATIONS CLIENT",
            "detail_shipping_heading": "INFORMATIONS DE LIVRAISON",
            "detail_additional_heading": "INFORMATIONS SUPPLÉMENTAIRES",
            "detail_no_notes": "Aucune note",
            "detail_deleted_product": "Produit supprimé",
            "detail_awaiting_merchant": "En attente du commerçant",
            "create_similar_quote": "Créer un devis similaire",
            "fallback_error_heading": "Une erreur est survenue",
            "fallback_error_message": "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer ou contacter le commerçant",
            "link_error_heading": "Erreur de lien",
            "link_error_message": "Ce lien a expiré. Veuillez contacter le commerçant pour recevoir une nouvelle proposition.",
            "approved_error_heading": "Devis déjà approuvé",
            "approved_error_message": "Ce devis a déjà été approuvé. Vous pouvez consulter son statut actuel dans votre historique de devis.",
            "rejected_error_heading": "Devis déjà rejeté",
            "rejected_error_message": "Ce devis a déjà été rejeté. Vous pouvez consulter son statut actuel dans votre historique de devis.",
            "approve_success_heading": "Devis approuvé avec succès",
            "approve_success_message": "Le devis a été approuvé avec succès. Veuillez vérifier votre boîte de réception pour consulter votre facture.",
            "reject_success_heading": "Devis rejeté avec succès",
            "reject_success_message": "Le devis a été rejeté avec succès. Vous pouvez consulter les informations mises à jour dans les détails du devis.",
            "reject_modal_title": "Confirmer le rejet",
            "reject_modal_message": "Êtes-vous sûr de vouloir rejeter ce devis ? Vous pouvez éventuellement indiquer un motif ci-dessous.",
            "reject_cancel_button": "Annuler",
            "reject_confirm_button": "Confirmer"
        };
    } else if (window.Shopify?.locale === "es") {
        BSS_BCP_V2.r4q.translation = {
            "quote_button_content": "Añadir a la cotización",
            "total_quantity": "Cantidad totale",
            "modal_header_title": "Solicitud de cotización",
            "product_section_heading": "Productos cotizados",
            "product_table_product_variant": "Variante: ",
            "product_table_product_sku": "SKU: ",
            "product_table_product_barcode": "Código de barras: ",
            "product_table_product_type": "Tipo: ",
            "product_table_product_vendor": "Proveedor: ",
            "product_table_product_available_quantity": "Cantidad disponible: ",
            "product_table_product_offer_button": "Ofrecer precio",
            "product_table_product_offer_price": "Precio ofrecido: ",
            "product_table_product_offer_placeholder": "Tu precio",
            "product_table_product_note_placeholder": "Añadir requisitos adicionales para este producto",
            "product_empty_heading": "No hay artículos en tu lista de solicitud de cotización",
            "product_empty_message": "Por favor, busca y añade productos para solicitar una cotización",
            "add_items_success_heading": "Artículos añadidos a la lista de solicitud de cotización",
            "add_items_success_message": "Has añadido con éxito los artículos a tu lista de solicitud de cotización.",
            "add_items_failure_heading": "Error al añadir artículos",
            "add_items_failure_message": "Hubo un problema al añadir los artículos a tu lista de solicitud de cotización. Por favor, inténtalo de nuevo.",
            "toast_view_quote_button": "Ver lista de solicitud de cotización",
            "eligible_notice_title": "Aviso de elegibilidad para solicitud de cotización",
            "eligible_all_items_invalid": "Desafortunadamente, ninguno de los artículos es elegible para una solicitud de cotización. Por favor, añade productos elegibles para continuar.",
            "eligible_exist_invalid_items": "Ciertos artículos no son elegibles para una cotización:",
            "eligible_continue_or_return": "Puedes proceder a continuar con los artículos elegibles o regresar para ajustar.",
            "eligible_return_button": "Regresar",
            "eligible_continue_button": "Continuar",
            "form_section_heading": "Completar información",
            "modal_footer_cancel_button": "Continuar comprando",
            "modal_footer_submit_button": "Enviar solicitud",
            "state_file_uploading": "Subiendo archivo",
            "file_choose_button": "Seleccionar archivo",
            "file_replace_button": "Reemplazar archivo",
            "after_submit_heading": "Solicitud de cotización enviada con éxito",
            "after_submit_message": "Hemos recibido tu solicitud de cotización. Nuestro equipo la revisará y se pondrá en contacto contigo en breve.",
            "after_submit_quote_id": "ID de cotización: #",
            "after_submit_back_button": "Volver a la tienda",
            "error_required": "{{label}} es obligatorio",
            "error_invalid": "{{label}} no es válido",
            "error_file_type": "El tipo de archivo debe ser uno de los siguientes: .csv, .doc, .docx, .gif, .jpg, .jpeg, .png, .pdf, .wav, .xls, .xlsx, .zip, .mp4, .txt",
            "error_file_size": "El tamaño del archivo no debe exceder los {{maxSize}}MB",
            "error_video_size": "El tamaño del video no debe exceder los {{maxSize}}MB",
            "error_video_width": "El ancho del video debe estar entre {{minWidth}}px y {{maxWidth}}px",
            "error_video_height": "La altura del video debe estar entre {{minHeight}}px y {{maxHeight}}px",
            "error_video_resolution": "La resolución del video no debe exceder los {{maxResolution}}MP",
            "error_video_duration": "La duración del video debe estar entre {{minDuration}} segundos y {{maxDuration}} segundos",
            "error_image_size": "El tamaño de la imagen no debe exceder los {{maxSize}}MB",
            "error_image_aspect_ratio": "La relación de aspecto de la imagen debe estar entre {{minAspectRatio}} y {{maxAspectRatio}}",
            "error_image_resolution": "La resolución de la imagen no debe exceder los {{maxResolution}}MP",
            "error_min_value": "{{label}} debe ser mayor o igual a {{min}}",
            "error_max_value": "{{label}} debe ser menor o igual a {{max}}",
            "error_min_length": "{{label}} no ha alcanzado el límite mínimo de {{minLength}} caracteres",
            "error_max_length": "{{label}} ha excedido el límite máximo de {{maxLength}} caracteres",
            "history_created_at": "Fecha de creación",
            "history_restricted_heading": "Esta página es solo para clientes registrados",
            "history_restricted_description": "Por favor, inicia sesión en tu cuenta para acceder a esta página",
            "history_restricted_primary_button": "Iniciar sesión",
            "history_restricted_secondary_button": "Volver",
            "history_page_title": "Mi historial de cotizaciones",
            "history_page_subtitle": "Realiza un seguimiento de tus cotizaciones creadas y accede a los detalles completos de cada solicitud.",
            "history_search_quote": "Buscar cotización",
            "history_filter_status": "Estado",
            "history_filter_all": "Todos",
            "history_sort_by": "Ordenar por",
            "history_sort_newest": "Más reciente",
            "history_sort_oldest": "Más antiguo",
            "history_empty_heading": "No hay cotizaciones disponibles",
            "history_empty_description": "Tu lista de cotizaciones está vacía o ninguna cotización coincide con tu búsqueda y filtros",
            "history_quote_name": "Cotización #",
            "history_table_customer": "Cliente",
            "history_table_company": "Empresa",
            "history_table_location": "Ubicación",
            "quote_status_unread": "No leído",
            "quote_status_review": "En revisión",
            "quote_status_converted": "Convertido",
            "quote_status_rejected": "Rechazado",
            "quote_proposal_sent": "Propuesta enviada",
            "detail_page_title": "Detalle de cotización #",
            "detail_table_product": "PRODUCTO",
            "detail_table_quoted_price": "PRECIO COTIZADO",
            "detail_table_quantity": "CANTIDAD",
            "detail_table_total": "TOTAL",
            "detail_table_sku": "SKU",
            "detail_table_barcode": "Código de barras",
            "detail_table_vendor": "Proveedor",
            "detail_table_note": "Nota",
            "detail_payment_heading": "INFORMACIÓN DE PAGO",
            "detail_payment_subtotal": "Subtotal",
            "detail_payment_items": "artículo(s)",
            "detail_payment_shipping": "Envío",
            "detail_payment_tax": "Impuesto",
            "detail_payment_total": "Monto final",
            "detail_payment_tax_exempt": "Exento de impuestos",
            "detail_payment_taxes_included": "Incluido",
            "detail_checkout_button": "PROCEDER AL PAGO",
            "detail_payment_terms": "CONDICIONES DE PAGO",
            "detail_customer_heading": "INFORMACIÓN DEL CLIENTE",
            "detail_shipping_heading": "INFORMACIÓN DE ENVÍO",
            "detail_additional_heading": "INFORMACIÓN ADICIONAL",
            "detail_no_notes": "Sin notas",
            "detail_deleted_product": "Producto eliminado",
            "detail_awaiting_merchant": "Esperando al comerciante",
            "create_similar_quote": "Crear cotización similar",
            "fallback_error_heading": "Algo salió mal",
            "fallback_error_message": "Ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo o contacta al comerciante",
            "link_error_heading": "Error de enlace",
            "link_error_message": "Este enlace ha expirado. Por favor, contacta al comerciante para recibir una nueva propuesta.",
            "approved_error_heading": "Cotización ya aprobada",
            "approved_error_message": "Esta cotización ya ha sido aprobada. Puedes ver su estado actual en tu Historial de cotizaciones.",
            "rejected_error_heading": "Cotización ya rechazada",
            "rejected_error_message": "Esta cotización ya ha sido rechazada. Puedes ver su estado actual en tu Historial de cotizaciones.",
            "approve_success_heading": "Cotización aprobada con éxito",
            "approve_success_message": "La cotización ha sido aprobada con éxito. Por favor, revisa tu bandeja de entrada para ver tu factura.",
            "reject_success_heading": "Cotización rechazada con éxito",
            "reject_success_message": "La cotización ha sido rechazada con éxito. Puedes revisar la información actualizada en los detalles de la cotización.",
            "reject_modal_title": "Confirmar rechazo",
            "reject_modal_message": "¿Estás seguro de que deseas rechazar esta cotización? Opcionalmente puedes proporcionar una razón a continuación.",
            "reject_cancel_button": "Cancelar",
            "reject_confirm_button": "Confirmar"
        };
    }
}

// Customize label for r4q form fields
if (window.BSS_BCP_V2?.r4q?.logics?.[0]?.formFields?.length) {
    const formFields = BSS_BCP_V2.r4q.logics[0].formFields;

    if (window.Shopify?.locale === "fr") {
        formFields[0].label = "Informations générales";
        formFields[1].label = "Prénom";
        formFields[2].label = "Nom";
        formFields[3].label = "E-mail";
        formFields[4].label = "Adresse de livraison";
        formFields[4].fields[0].label = "Adresse de livraison";
        formFields[4].fields[1].fields[0].label = "Pays/Région";
        formFields[4].fields[1].fields[1].label = "Province/État";
        formFields[4].fields[2].label = "Prénom";
        formFields[4].fields[3].label = "Nom";
        formFields[4].fields[4].label = "Entreprise";
        formFields[4].fields[5].label = "Adresse";
        formFields[4].fields[6].label = "Appartement, suite, etc.";
        formFields[4].fields[7].label = "Ville";
        formFields[4].fields[8].label = "Code postal";
        formFields[4].fields[9].label = "Téléphone";
    } else if (window.Shopify?.locale === "es") {
        formFields[0].label = "Información general";
        formFields[1].label = "Nombre";
        formFields[2].label = "Apellido";
        formFields[3].label = "Correo electrónico";
        formFields[4].label = "Dirección de envío";
        formFields[4].fields[0].label = "Dirección de envío";
        formFields[4].fields[1].fields[0].label = "País/Región";
        formFields[4].fields[1].fields[1].label = "Provincia/Estado";
        formFields[4].fields[2].label = "Nombre";
        formFields[4].fields[3].label = "Apellido";
        formFields[4].fields[4].label = "Empresa";
        formFields[4].fields[5].label = "Dirección";
        formFields[4].fields[6].label = "Apartamento, habitación, etc.";
        formFields[4].fields[7].label = "Ciudad";
        formFields[4].fields[8].label = "Código postal";
        formFields[4].fields[9].label = "Teléfono";
    }
}